
import vivewBase from './modules/zh-TW/vivewBase'
import routerBase from './modules/zh-TW/routerBase'
export default {
  ...vivewBase,
  ...routerBase
}
